import React from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components";
import { theme } from "./theme";
import AdminHeader from "./components/AdminHeader";
import ToastContainer from "./components/ToastContainer";

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: ${theme.colors.bg};
  font-family: ${theme.fonts.body};
`;

const MainContent = styled.main`
  flex: 1;
  padding: 32px;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
`;

const AdminLayout = () => {
  return (
    <LayoutContainer>
      <AdminHeader />
      <MainContent>
        <Outlet />
      </MainContent>
      <ToastContainer />
    </LayoutContainer>
  );
};

export default AdminLayout;
